module.exports = __webpack_public_path__ + "static/media/STAF_bokmål_sekundærlogo_neg(hvit).b12379e3.png";